/**
 * Thrown when an account specification of an `AccountFormulaNode`
 * can't be converted to an instance of `AbstractFormulaToken`. This
 * conversion is done by the `SpecificationTokenizer`.
 */
export default class SpecificationTokenizationError extends Error {
	constructor(specification, ...rest) {
		super(...rest);

		// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
		// Maintains proper stack trace for where our error was thrown
		if (Error.captureStackTrace) {
			Error.captureStackTrace(this, SpecificationTokenizationError);
		}

		this.name = "SpecificationTokenizationError";
		this.specification = specification;
	}
}
